import React from "react";

export const SPECTRAL_QUESTIONS = [
  {
    question: "What is the MACRO Score?",
    answer: (
      <>
        Short for Multi-Asset Credit Risk Oracle, the MACRO Score represents
        one's credit standing in Decentralized Finance (DeFi) and is calculated
        using many different pieces of on-chain transaction data. You can learn
        more{" "}
        <a
          href="https://docs.spectral.finance/macro-score/on-chain-credit-score"
          target="_blank"
          rel="noreferrer"
        >
          <b>here</b>
        </a>
        .
      </>
    ),
  },
  {
    question: "How is my MACRO Score calculated?",
    answer: (
      <>
        Your MACRO Score is calculated using five different categories of
        on-chain data: payment history, liquidation history, amounts owed and
        repaid, credit mix, and length of credit history. Each factor is
        weighted differently. You can learn more{" "}
        <a
          href="https://docs.spectral.finance/macro-score/on-chain-credit-score"
          target="_blank"
          rel="noreferrer"
        >
          <b>here</b>
        </a>
        .
      </>
    ),
  },
  {
    question: "If my MACRO Score is low, what does it mean?",
    answer: (
      <>
        A low MACRO Score indicates risky on-chain behavior or low on-chain
        activity. Improve your score by following the insights recommended by
        the Spectral Dashboard.
      </>
    ),
  },
  {
    question: "How can I improve my MACRO Score?",
    answer: (
      <>
        Your MACRO Score can be improved by building a consistent record of
        healthy lending and borrowing behavior. Your Spectral Dashboard contains
        different insights based on each of the five factors used to determine
        your score. Follow the course of action recommended by the Dashboard to
        improve it.
      </>
    ),
  },
  {
    question: "How often does my MACRO Score update?",
    answer: (
      <>
        The MACRO score updates at loan origination as well as when prompted by
        the primary wallet.
      </>
    ),
  },
  {
    question: "How long is my MACRO Score valid for?",
    answer: (
      <>
        Your current MACRO score is valid until the next time an NFC is used.{" "}
      </>
    ),
  },
  {
    question: "Can I keep my MACRO score private?",
    answer: (
      <>
        Yes! There are two ways. You will have the option to create a public or
        a private bundle during the minting process. If you choose a public
        bundle then your MACRO Score will be pushed on-chain, linking it to your
        primary wallet. We encourage users to create a new wallet as their
        primary wallet when they create an NFC to obfuscate their other bundled
        wallets.
      </>
    ),
  },
  {
    question: "Can anyone check my MACRO Score?",
    answer: (
      <>
        No! Only a wallet owner may initiate the scoring process. Loan
        origination or using the Spectral Dashboard are the only ways to create
        or check a MACRO Score.
      </>
    ),
  },
  {
    question: "Where can I learn more about the MACRO Score?",
    answer: (
      <>
        You can check “How is my MACRO score calculated?” higher up here in our
        FAQ or navigate to our documentation{" "}
        <a
          href="https://docs.spectral.finance/macro-score/on-chain-credit-score"
          target="_blank"
          rel="noreferrer"
        >
          <b>here</b>
        </a>
        .
      </>
    ),
  },
  {
    question: "How do I provide feedback about my MACRO Score?",
    answer: (
      <>
        Please contact us at{" "}
        <a
          href="mailto:contact@spectral.finance"
          target="_blank"
          rel="noreferrer"
        >
          <b>contact@spectral.finance</b>
        </a>
        , or jump in our Discord{" "}
        <a href="https://discord.gg/Z9ESSwy" target="_blank" rel="noreferrer">
          <b>here</b>
        </a>
        !
      </>
    ),
  },
  {
    question: "How up-to-date is my MACRO score?",
    answer: <>Your MACRO Score is recalculated every time it is requested.</>,
  },
];
